import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

import { SORTING_ARROW_SVG } from 'components/ui/_shared/SVG';
import { SortingArrowStyled } from './styled';

export const SortingArrow = ({ isSelected, isAsc }) => {
  const theme = useTheme();

  return (
    <SortingArrowStyled>
      {isSelected && (
        <SORTING_ARROW_SVG
          isUp={isAsc}
          color={theme.brand400}
        />
      )}
    </SortingArrowStyled>
  );
};

SortingArrow.propTypes = {
  isSelected: PropTypes.bool,
  isAsc: PropTypes.bool,
};
